import mapValues from 'lodash-es/mapValues'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { getMockListingApplicantsCount } from '../../../../RentalPortalApplicant'
import { LISTING_PROFILE_TAB_APPLICANTS } from '../../../RentalPortal.constants'
import { getRentalPortalProfileTabCount } from '../../../RentalPortal.utils'
import { getMockListingViewingsCount } from '../../RentalPortalListingViewings.mocks'

import { LISTING_PROFILE_TAB_VIEWINGS } from './RentalPortalListingProfileTabs.constants'

// TODO: count the applicants and viewings tabs from the served data once they leave the mock
function getListingProfileMockTabCounts(listingId) {
  return {
    [LISTING_PROFILE_TAB_APPLICANTS]: getMockListingApplicantsCount(listingId),
    [LISTING_PROFILE_TAB_VIEWINGS]: getMockListingViewingsCount(listingId),
  }
}

export function getListingProfileTabCounters(listingData) {
  return mapValues(
    {
      ...(listingData?.counts || EMPTY_OBJECT),
      ...(listingData ? getListingProfileMockTabCounts(listingData.id) : null),
    },
    total => ({ total: getRentalPortalProfileTabCount(total) })
  )
}
